<app-language-attribute></app-language-attribute>
<app-header class="rsp-header" [attr.inert]="disableFocusOnBackgroundElements || null"></app-header>
@if (areTranslationsAvailable) {
  <main
    class="rsp-container"
    role="main"
    [attr.inert]="disableFocusOnBackgroundElements || null"
    aria-live="polite"
    [attr.aria-busy]="spinnerOverlayService.showSpinnerOverlayDelayed$ | async"
  >
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-footer class="rsp-footer"></app-footer>
}

<div aria-live="assertive">
  @if (!areTranslationsAvailable || (spinnerOverlayService.showSpinnerOverlayDelayed$ | async)) {
    <app-spinner-overlay></app-spinner-overlay>
  }
</div>
